module.exports = "verificado\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/verifyAzureLogin/view/verifyAzureLogin.component.html
// module id = ../../../../../src/app/autenticacion/verifyAzureLogin/view/verifyAzureLogin.component.html
// module chunks = main